module.exports = __webpack_public_path__ + "media/images/gallery/lines_on-57fea1390aa8f9fbe5bf677c8d44c85d.gif";